import '../styles/Hero.css';
import { useState } from 'react';
import { Link } from 'react-router-dom';

function Hero({breadcrumb, banner, title, subtitle, items, noItems}) {

  const [activePopup, setActivePopup] = useState(null);

  return (
    <>
      <div className='banner-hero'>
        <img src={banner} alt={title} />
        <div className='entry-header'>
          {breadcrumb && breadcrumb.length ? (
            <div className='breadcrumb'>
              <ul>
                {breadcrumb.map((item, index) => (
                  item.link ? (
                    <li><Link to={item.link}>{item.title}</Link></li>
                  ) : <li>{item.title}</li>
                  ))}
              </ul>
            </div>
          ) : ''}
          <h1>{title}</h1>
        </div>
        <div className='entry-content'>
          <h2>{subtitle} <br/> en cours chez AbbVie :</h2>
          <div className='items'>
          {items && items.length ? (
            items.map((item, index) => (
              item.popup ? (
                <Link
                  key={index}
                  className="external-link popup-link"
                  onClick={() => setActivePopup(item.popup)}
                >
                  <span className="itemTitle">{item.title}</span>
                  <span className="itemSubtitle">{item.subtitle}</span>
                </Link>
              ) : (
                <Link
                  key={index}
                  to={item.link}
                  target="_blank"
                  className="external-link"
                >
                  <span className="itemTitle">{item.title}</span>
                  <span className="itemSubtitle">{item.subtitle}</span>
                </Link>
              )
            ))
          ) :
            <p className='no-items'>{noItems}</p>
          }
          </div>
        </div>
      </div>
      {activePopup && (
        <div className="popup-overlay" onClick={() => setActivePopup(null)}>
          <div
            className="popup"
            onClick={(event) => event.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-labelledby="hero-popup-title"
          >
            <button
              type="button"
              className="popup-close"
              aria-label="Fermer"
              onClick={() => setActivePopup(null)}
            >
              ×
            </button>

            <h2 id="hero-popup-title">{activePopup.popupTitle}</h2>
            <div className="popup-content">{activePopup.popupContent}</div>
          </div>
        </div>
      )}
    </>
  )
}

export default Hero